import * as React from "react";
import { FileViewer } from "./FileViewer";
import { useDispatch, useSelector } from "react-redux";
import { ApplicationState } from "src/store";
import { useParams } from "react-router";
import { previewUploadedDocument } from "src/actionCreators/documentRequestActionCreators";

export const PreviewUplodedFileModal: React.FC = () => {
    const documentState = useSelector((state: ApplicationState) => state.previewDocumentState);
    const dispatch = useDispatch();
    const params = useParams();
    const { fileName, fileType, fileGuid, requestedYear } = params;

    React.useEffect(() => {
        dispatch(previewUploadedDocument(fileName, fileGuid, Number(requestedYear), fileType));
    }, []);

    return (
        <div className="pdfmodal">
            <div className="settings-wrapper">
                <header className="modal-header">
                    <div title={documentState.previewFileDetails.fileName} className="header-preview">{documentState.previewFileDetails.fileName}</div>
                </header>
                <main>
                    <div className="settings-tab-wrapper">
                        <FileViewer />
                    </div>
                </main>
            </div>
        </div>
    );
};
